import { ICurrentInfo } from '../interface';
import { lang } from '@umu/ukit-lang';
const defaultCurrentInfo: ICurrentInfo = {
    list: [],
    currentIndex: 0,
    value: '',
    total: 0,
    isLoading: false,
};
const PLACEHOLDER_TEXT = lang('在文档中搜索');

export { defaultCurrentInfo, PLACEHOLDER_TEXT };
